import React from 'react';
import visa from '../assets/images/visa.svg';
import mastercard from '../assets/images/mastercard.svg';
import amex from '../assets/images/amex.svg';
import discover from '../assets/images/discover.svg';
import { inject } from 'mobx-react';

@inject('store')
class PaymentMethodsAccepted extends React.Component {
    render() {
        return (
            <div>
                {this.props.store.paymentPage.paymentMethods.methods.visa && <img alt="" className="visa" src={visa} /> }
                {this.props.store.paymentPage.paymentMethods.methods.mastercard && <img alt="" className="mastercard" src={mastercard} />}
                {this.props.store.paymentPage.paymentMethods.methods.discover && <img alt="" className="discover" src={discover} />}
                {this.props.store.paymentPage.paymentMethods.methods.amex && <img alt="" className="amex" src={amex} />}
            </div>
        );
    }
}

export { PaymentMethodsAccepted };